@if (showModifyTermsAndConditions()) {
  <div>
    @if (!quoteTerms && !!editorEnabled) {
      <div class="loading">Loading Terms & Conditions...</div>
    }
    @if (quoteTerms && !!editorEnabled) {
      <app-wysiwyg
        (valueChanged)="termsChangeSubject.next($event)"
        [showToolbarItems]="isShowToolbarItems()"
        [value]="editableTerms"
        [readonly]="!editorEnabled"
        [class.disabled]="!editorEnabled"
      >
      </app-wysiwyg>
    }
  </div>
}
